import { useEffect, useMemo, useState } from "react";
import {
  fetchBillingPlans,
  startCheckout,
} from "../../../store/slices/billingSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useTranslation } from "../../../translations/i18n";

export const useSubscriptionScreen = () => {
  const dispatch = useAppDispatch();
  const { t, language } = useTranslation();
  const { account } = useAppSelector((state) => state.auth);
  const { plans, loading, error } = useAppSelector((state) => state.billing);
  const [selectedPeriodMonths, setSelectedPeriodMonths] = useState(1);

  useEffect(() => {
    dispatch(fetchBillingPlans());
  }, [dispatch]);

  const availablePeriods = useMemo(() => {
    const months = new Set<number>();

    plans.forEach((plan) => {
      plan.prices.forEach((price) => months.add(price.period_months));
    });

    return Array.from(months).sort((a, b) => a - b);
  }, [plans]);

  const choosePrice = (subscriptionPriceId: number) => {
    dispatch(startCheckout(subscriptionPriceId));
  };

  const manageBilling = () => {
    return;
  };

  return {
    t,
    language,
    account,
    plans,
    availablePeriods,
    selectedPeriodMonths,
    setSelectedPeriodMonths,
    loading,
    error,
    choosePrice,
    manageBilling,
  };
};
